<template>
<div class="bg-white">
    <lheader />
    <llanding />
    <!--<lcourses v-if="showTopRated" id="courses" />-->
    <lservices id="services" />
    <labout id="about" />
    <lstats :stats="tenantSettings" id="stats" />
    <ltestimonials v-if="showTestimonial" />
    <lcontact class="my-8" id="contact" />

    <lfooter :text="tenantSettings.footer_text" />

</div>
</template>

<script>
import SettingsMixin from "@/mixins/SettingsMixin";
import {
    mapActions,
    mapGetters
} from "vuex";
export default {
    mixins: [SettingsMixin],
    components: {
        lheader: () => import("@/components/shared/home/header"),
        llanding: () => import("@/components/shared/home/landing"),
        labout: () => import("@/components/shared/home/about"),
        lservices: () => import("@/components/shared/home/services"),
        lcourses: () => import("@/components/shared/home/courses"),
        lstats: () => import("@/components/shared/home/stats"),
        ltestimonials: () => import("@/components/shared/home/testimonials"),
        lcontact: () => import("@/components/shared/home/contact"),
        lfooter: () => import("@/components/shared/home/footer"),
    },
    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            tenantSettings: "getSettings",
            getPrefix: "getPrefix"
        }),
    },
    methods: {
        ...mapActions(["fetchTenantSettings"]),

    },
    created() {
        let prefix = new URL(this.getURI).host.split(".")[0]; //chnage url to window.location.href when we go live
        if (prefix === 'web') {
            prefix = new URL(this.getURI).host.split(".")[1];
        }
        this.fetchTenantSettings({
            prefix: prefix
        });
    },
};
</script>

<style lang="scss" scoped>

</style>
